// Exports
module.exports = {
	"tekst": "dh-lyspunkt-v0-tekst-3d6_H"
};
